import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { PulseLayout, usePulseMeta, C } from "./PulseLayout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pulse/launch`;

export default function PulseUnsubscribe() {
  usePulseMeta("Unsubscribe — PULSE by Veyronix", "Unsubscribe from PULSE by Veyronix launch updates.", "/pulse/unsubscribe");
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ status: token ? "idle" : "error", msg: token ? "" : "This unsubscribe link is incomplete. Please use the link in your email, or contact privacy@veyronix.co.uk." });
  const confirm = async () => {
    setState({ status: "sending", msg: "" });
    try {
      const res = await fetch(`${API}/unsubscribe`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token }) });
      const data = await res.json().catch(() => ({}));
      setState(res.ok ? { status: "done", msg: data.message } : { status: "error", msg: typeof data.detail === "string" ? data.detail : "Something went wrong. Please try again." });
    } catch {
      setState({ status: "error", msg: "We couldn't reach the server. Please try again." });
    }
  };
  return (
    <PulseLayout>
      <section className="max-w-xl mx-auto px-5 py-24 text-center" data-testid="pulse-unsubscribe">
        <h1 className="font-heading text-3xl font-bold mb-4">Unsubscribe from PULSE launch updates</h1>
        {state.status === "done" || state.status === "error" ? (
          <p className="mb-8" style={{ color: state.status === "error" ? "#F59E9E" : C.cyan }} role="status" data-testid={`pulse-unsubscribe-${state.status}`}>{state.msg}</p>
        ) : (
          <>
            <p className="mb-8" style={{ color: C.silver }}>Confirm below and we will stop sending you PULSE launch emails.</p>
            <button type="button" onClick={confirm} disabled={state.status === "sending"} className="rounded-full px-7 py-3 font-semibold disabled:opacity-60" style={{ background: C.cyan, color: C.navy }} data-testid="pulse-unsubscribe-confirm">
              {state.status === "sending" ? "Unsubscribing…" : "Confirm unsubscribe"}
            </button>
          </>
        )}
        <p className="mt-10 text-sm"><Link to="/pulse" className="underline" style={{ color: C.cyan }}>Back to PULSE</Link></p>
      </section>
    </PulseLayout>
  );
}
